import { render } from "./PagesPage.vue?vue&type=template&id=41311a72"
import script from "./PagesPage.vue?vue&type=script&lang=js"
export * from "./PagesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__